import { imageUrl } from '@helpers/image';
import { Device, from } from '@helpers/media';
import { withMotion } from '@hoc/withMotion';
import React from 'react';
import S from './HeroLanding.styles';
const HeroLanding = ({ content, height = 'default', image, subtitle, title, transitionDelay = 1000, transitionDuration = 1000, gradientOverlayPercentage, }) => {
    return (React.createElement(S.Container, { flush: "both", fullWidth: true, "data-height": height },
        React.createElement(S.Inner, { initial: "default", animate: "visible" },
            image && (React.createElement(S.ImageWrapper, null,
                React.createElement("picture", null,
                    React.createElement("source", { media: from(Device.TabletLarge), srcSet: [
                            `${imageUrl(image, { heightratio: 0.4255, width: 360 })} 360w`,
                            `${imageUrl(image, { heightratio: 0.4255, width: 480 })} 480w`,
                            `${imageUrl(image, { heightratio: 0.4255, width: 960 })} 960w`,
                            `${imageUrl(image, { heightratio: 0.4255, width: 1440 })} 1440w`,
                            `${imageUrl(image, { heightratio: 0.4255, width: 1920 })} 1920w`,
                        ].join(',') }),
                    React.createElement(S.Image, { alt: "", loading: "eager", role: "presentation", sizes: "100vw", src: imageUrl(image, { heightratio: 0.5306, width: 1920 }), srcSet: [
                            `${imageUrl(image, { heightratio: 0.5306, width: 360 })} 360w`,
                            `${imageUrl(image, { heightratio: 0.5306, width: 480 })} 480w`,
                            `${imageUrl(image, { heightratio: 0.5306, width: 960 })} 960w`,
                            `${imageUrl(image, { heightratio: 0.5306, width: 1440 })} 1440w`,
                            `${imageUrl(image, { heightratio: 0.5306, width: 1920 })} 1920w`,
                        ].join(','), variants: {
                            default: {
                                scale: 1,
                            },
                            visible: {
                                scale: 1.1,
                            },
                        }, transition: {
                            type: 'tween',
                            duration: (transitionDuration + transitionDelay) / 1000,
                            ease: 'easeOut',
                        } })))),
            React.createElement(S.Overlay, { gradientOverlayPercentage: gradientOverlayPercentage, variants: {
                    default: {
                        opacity: 0,
                    },
                    visible: {
                        opacity: 1,
                    },
                }, transition: {
                    type: 'tween',
                    duration: transitionDuration / 1000,
                    ease: 'easeOut',
                    delay: transitionDelay / 1000,
                } }),
            React.createElement(S.ContentWrapper, null,
                React.createElement(S.ContentWrapperInner, null,
                    subtitle && (React.createElement(S.Subtitle, { variants: {
                            default: {
                                opacity: 0,
                                x: -20,
                            },
                            visible: {
                                opacity: 1,
                                x: 0,
                            },
                        }, transition: {
                            type: 'tween',
                            duration: 0.6,
                            ease: 'easeOut',
                            delay: transitionDelay / 1000 + 0.3,
                        } }, subtitle)),
                    title && (React.createElement(S.Title, { variants: {
                            default: {
                                opacity: 0,
                                x: -20,
                            },
                            visible: {
                                opacity: 1,
                                x: 0,
                            },
                        }, transition: {
                            type: 'tween',
                            duration: 0.6,
                            ease: 'easeOut',
                            delay: transitionDelay / 1000 + 0.6,
                        } }, title)),
                    content && (React.createElement(S.Content, { variants: {
                            default: {
                                opacity: 0,
                                x: -20,
                            },
                            visible: {
                                opacity: 1,
                                x: 0,
                            },
                        }, transition: {
                            type: 'tween',
                            duration: 0.6,
                            ease: 'easeOut',
                            delay: transitionDelay / 1000 + 0.9,
                        }, dangerouslySetInnerHTML: { __html: content } })),
                    React.createElement(S.Line, { variants: {
                            default: {
                                scaleY: 0,
                            },
                            visible: {
                                scaleY: 1,
                            },
                        }, transition: {
                            type: 'tween',
                            duration: 0.6,
                            ease: 'easeOut',
                            delay: transitionDelay / 1000 + 1.2,
                        } }))))));
};
export default withMotion(HeroLanding);
